export default __webpack_public_path__ + "static/illustration-content-logo.url-59c077b12066dcd14e3cd958f97b4c81.svg";